import { render, staticRenderFns } from "./AngelInvestment.vue?vue&type=template&id=0d7d1e8b&scoped=true&"
import script from "./AngelInvestment.vue?vue&type=script&lang=js&"
export * from "./AngelInvestment.vue?vue&type=script&lang=js&"
import style0 from "./AngelInvestment.vue?vue&type=style&index=0&id=0d7d1e8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7d1e8b",
  null
  
)

export default component.exports